/**
 * @generated SignedSource<<b920480167afef8d2264dee6d671aefa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityTypeEnum = "assignment" | "call" | "change" | "create_user" | "email" | "match" | "note" | "offer" | "origination" | "requalification" | "task" | "visit";
export type EmailVisibilityTypeEnum = "organisation" | "private" | "shared";
export type OfferStatus = "accepted" | "pending" | "refused";
export type ParticipantStatus = "maybe" | "no" | "noreply" | "yes";
export type UpsertActivityInput = {
  activity: ActivityInput;
  clientMutationId?: string | null;
  notifyParticipants?: boolean | null;
};
export type ActivityInput = {
  activityType?: ActivityTypeEnum | null;
  assignedTo?: string | null;
  createdBy?: string | null;
  done?: boolean | null;
  doneAt?: string | null;
  dueAt?: string | null;
  endAt?: string | null;
  endDate?: string | null;
  id?: string | null;
  location?: string | null;
  note?: string | null;
  offerStatus?: OfferStatus | null;
  parentId?: string | null;
  participants?: ReadonlyArray<ActivityParticipantInput | null> | null;
  pinned?: boolean | null;
  startDate?: string | null;
  subject?: string | null;
  success?: boolean | null;
  visibility?: EmailVisibilityTypeEnum | null;
};
export type ActivityParticipantInput = {
  email?: string | null;
  id?: string | null;
  name?: string | null;
  status?: ParticipantStatus | null;
};
export type activityWorkflowDialogMutation$variables = {
  input: UpsertActivityInput;
};
export type activityWorkflowDialogMutation$data = {
  readonly upsertActivity: {
    readonly activity: {
      readonly success?: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"FeedCall_activity" | "FeedEmail_activity" | "FeedNote_activity" | "FeedTask_activity" | "FeedVisit_activity">;
    } | null;
  } | null;
};
export type activityWorkflowDialogMutation = {
  response: activityWorkflowDialogMutation$data;
  variables: activityWorkflowDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryImage",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedAddress",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = [
  (v4/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Email",
    "kind": "LinkedField",
    "name": "primaryEmail",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Organisation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Subscription",
    "kind": "LinkedField",
    "name": "subscription",
    "plural": false,
    "selections": [
      (v12/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  }
],
v14 = [
  (v4/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Property",
  "kind": "LinkedField",
  "name": "property",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  (v4/*: any*/),
  (v10/*: any*/),
  (v9/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canEdit",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueAt",
  "storageKey": null
},
v23 = [
  (v3/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Enquiry",
  "kind": "LinkedField",
  "name": "enquiry",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Lot",
  "kind": "LinkedField",
  "name": "lot",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "LeadStage",
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Pipeline",
      "kind": "LinkedField",
      "name": "pipeline",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "leadType",
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "BuyerLead",
  "kind": "LinkedField",
  "name": "buyerLead",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedNumber",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "primaryPhoneNumber",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    (v30/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "contact",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v34 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Lot",
    "kind": "LinkedField",
    "name": "lot",
    "plural": false,
    "selections": [
      (v33/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  }
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v36 = [
  (v10/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gender",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Email",
        "kind": "LinkedField",
        "name": "primaryEmail",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PhoneNumber",
        "kind": "LinkedField",
        "name": "primaryPhoneNumber",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v30/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activityWorkflowDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertActivityPayload",
        "kind": "LinkedField",
        "name": "upsertActivity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FeedVisit_activity"
                  }
                ],
                "type": "ActivityVisit",
                "abstractKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedCall_activity"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedEmail_activity"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FeedTask_activity"
                  }
                ],
                "type": "ActivityTask",
                "abstractKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedNote_activity"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "activityWorkflowDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertActivityPayload",
        "kind": "LinkedField",
        "name": "upsertActivity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isActivity"
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "assignedTo",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityParticipant",
                "kind": "LinkedField",
                "name": "displayParticipants",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityParticipant",
                "kind": "LinkedField",
                "name": "participants",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v8/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Enquiry",
                "kind": "LinkedField",
                "name": "enquiry",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Lot",
                "kind": "LinkedField",
                "name": "lot",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Lead",
                "kind": "LinkedField",
                "name": "lead",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgagePropertyValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageInsuranceRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgagePurchaseDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageStartDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "mortgageLender",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "mortgageInsuranceProvider",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mandateProbability",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "predictedListingDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LeadStage",
                    "kind": "LinkedField",
                    "name": "stage",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Lot",
                    "kind": "LinkedField",
                    "name": "lot",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerLead",
                "kind": "LinkedField",
                "name": "buyerLead",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "location",
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ],
                        "type": "ActivityVisit",
                        "abstractKey": null
                      }
                    ],
                    "type": "Activity",
                    "abstractKey": "__isActivity"
                  }
                ],
                "type": "ActivityVisit",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v18/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Enquiry",
                    "kind": "LinkedField",
                    "name": "enquiry",
                    "plural": false,
                    "selections": (v34/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Lot",
                    "kind": "LinkedField",
                    "name": "lot",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Lead",
                    "kind": "LinkedField",
                    "name": "lead",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v26/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v31/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BuyerLead",
                    "kind": "LinkedField",
                    "name": "buyerLead",
                    "plural": false,
                    "selections": (v34/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActivityParticipant",
                    "kind": "LinkedField",
                    "name": "participants",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ActivityCall",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v19/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v35/*: any*/),
                          (v22/*: any*/),
                          (v18/*: any*/),
                          (v21/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ],
                        "type": "ActivityTask",
                        "abstractKey": null
                      }
                    ],
                    "type": "Activity",
                    "abstractKey": "__isActivity"
                  }
                ],
                "type": "ActivityTask",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v19/*: any*/)
                ],
                "type": "ActivityNote",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmailMessage",
                    "kind": "LinkedField",
                    "name": "emailMessage",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      (v35/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "from",
                        "plural": true,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "to",
                        "plural": true,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "cc",
                        "plural": true,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "bcc",
                        "plural": true,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "replyTo",
                        "plural": true,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "messageId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isSent",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "snippet",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailMessageFile",
                        "kind": "LinkedField",
                        "name": "emailMessageFiles",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nylasFileId",
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "size",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ActivityEmail",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aee12b33b7d50f12cb128bb44995281c",
    "id": null,
    "metadata": {},
    "name": "activityWorkflowDialogMutation",
    "operationKind": "mutation",
    "text": "mutation activityWorkflowDialogMutation(\n  $input: UpsertActivityInput!\n) {\n  upsertActivity(input: $input) {\n    activity {\n      __typename\n      ... on ActivityVisit {\n        success\n        ...FeedVisit_activity\n      }\n      ...FeedCall_activity\n      ...FeedEmail_activity\n      ... on ActivityTask {\n        success\n        ...FeedTask_activity\n      }\n      ...FeedNote_activity\n      id\n    }\n  }\n}\n\nfragment ConnectEmailForm_forwardMessage on EmailMessage {\n  ...EmailForm_forwardMessage\n}\n\nfragment ConnectEmailForm_replyToMessage on EmailMessage {\n  ...EmailForm_replyToMessage\n}\n\nfragment EmailForm_forwardMessage on EmailMessage {\n  id\n  date\n  body\n  subject\n  visibility\n  from {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  to {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  cc {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  bcc {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  replyTo {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  messageId\n  isSent\n}\n\nfragment EmailForm_replyToMessage on EmailMessage {\n  id\n  date\n  body\n  subject\n  visibility\n  from {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  to {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  cc {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  bcc {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  replyTo {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  messageId\n  isSent\n}\n\nfragment FeedCall_activity on Activity {\n  __isActivity: __typename\n  ...activityWorkflowDialog_activity\n  id\n  ... on ActivityCall {\n    canEdit\n    done\n    dueAt\n    startDate\n    success\n    note\n    enquiry {\n      __typename\n      id\n      lot {\n        lead {\n          contact {\n            primaryPhoneNumber {\n              number\n              formattedNumber\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    lot {\n      __typename\n      id\n      lead {\n        contact {\n          primaryPhoneNumber {\n            number\n            formattedNumber\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    lead {\n      __typename\n      id\n      stage {\n        pipeline {\n          leadType\n          id\n        }\n        id\n      }\n      contact {\n        primaryPhoneNumber {\n          number\n          formattedNumber\n          id\n        }\n        id\n      }\n    }\n    user {\n      __typename\n      id\n      primaryPhoneNumber {\n        number\n        formattedNumber\n        id\n      }\n    }\n    buyerLead {\n      __typename\n      id\n      lot {\n        lead {\n          contact {\n            primaryPhoneNumber {\n              number\n              formattedNumber\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    participants {\n      user {\n        primaryPhoneNumber {\n          number\n          formattedNumber\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment FeedEmail_activity on ActivityEmail {\n  id\n  emailMessage {\n    ...ConnectEmailForm_replyToMessage\n    ...ConnectEmailForm_forwardMessage\n    id\n    subject\n    status\n    snippet\n    to {\n      name\n      user {\n        id\n      }\n    }\n    from {\n      name\n      user {\n        id\n      }\n    }\n    cc {\n      name\n      user {\n        id\n      }\n    }\n    bcc {\n      name\n      user {\n        id\n      }\n    }\n    emailMessageFiles {\n      nylasFileId\n      name\n      size\n      id\n    }\n  }\n}\n\nfragment FeedNote_activity on Activity {\n  __isActivity: __typename\n  ... on ActivityNote {\n    note\n  }\n}\n\nfragment FeedTask_activity on Activity {\n  __isActivity: __typename\n  ...activityWorkflowDialog_activity\n  id\n  ... on ActivityTask {\n    canEdit\n    note\n    subject\n    dueAt\n    startDate\n    done\n    enquiry {\n      __typename\n      id\n    }\n    lot {\n      __typename\n      id\n    }\n    lead {\n      __typename\n      id\n      stage {\n        pipeline {\n          leadType\n          id\n        }\n        id\n      }\n    }\n    user {\n      __typename\n      id\n    }\n    buyerLead {\n      __typename\n      id\n    }\n  }\n}\n\nfragment FeedVisit_activity on Activity {\n  __isActivity: __typename\n  ...activityWorkflowDialog_activity\n  id\n  ... on ActivityVisit {\n    canEdit\n    done\n    dueAt\n    startDate\n    note\n    location\n    enquiry {\n      __typename\n      id\n    }\n    lot {\n      __typename\n      id\n    }\n    lead {\n      __typename\n      id\n      stage {\n        pipeline {\n          leadType\n          id\n        }\n        id\n      }\n    }\n    user {\n      __typename\n      id\n    }\n    buyerLead {\n      __typename\n      id\n    }\n  }\n}\n\nfragment activityWorkflowDialog_activity on Activity {\n  __isActivity: __typename\n  id\n  visibility\n  ... on ActivityVisit {\n    location\n    startDate\n    endDate\n    note\n  }\n  ... on ActivityCall {\n    note\n  }\n  ... on ActivityTask {\n    note\n  }\n  ... on ActivityNote {\n    note\n  }\n  assignedTo {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  createdBy {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  displayParticipants {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n  }\n  participants {\n    name\n    email\n    user {\n      id\n    }\n  }\n  enquiry {\n    id\n  }\n  lot {\n    id\n    property {\n      formattedAddress\n      id\n    }\n  }\n  lead {\n    ...financingWonDialog_lead\n    id\n    property {\n      formattedAddress\n      id\n    }\n    mandateProbability\n    predictedListingDate\n    stage {\n      id\n    }\n    lot {\n      id\n    }\n  }\n  user {\n    id\n  }\n  buyerLead {\n    id\n  }\n}\n\nfragment financingWonDialog_lead on Lead {\n  id\n  mortgageRevenue\n  mortgagePropertyValue\n  mortgageInsuranceRevenue\n  mortgagePurchaseDate\n  mortgageStartDate\n  mortgageLender {\n    id\n    name\n    primaryImage {\n      url\n      id\n    }\n  }\n  mortgageInsuranceProvider {\n    id\n    name\n    primaryImage {\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "566e62d9468bf5d17d8b1ac0ce0a2045";

export default node;
